import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b0073ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title leksa_title_50" }, "Добро пожаловать"),
  /*#__PURE__*/_createElementVNode("div", { class: "desc als fz20" }, "Войдите в свой личный кабинет, чтобы отслеживать заказы.")
], -1))
const _hoisted_3 = { class: "auth common--block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth--title leksa_title_50" }, "Вход", -1))
const _hoisted_5 = { class: "auth--container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Забыли пароль?", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Нет аккаунта? Зарегистрируйтесь", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_inputs = _resolveComponent("common-inputs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_common_inputs, {
          inputs: _ctx.auth.inputs,
          data: _ctx.auth.data,
          onInputHandler: _ctx.login
        }, null, 8, ["inputs", "data", "onInputHandler"]),
        _createElementVNode("div", {
          class: "reset flex justify-end als fz16 cursor",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.route('/reset')))
        }, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn btn--main btn--full",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
          }, "Войти")
        ]),
        _createElementVNode("div", {
          class: "flex justify-center als fz16 cursor",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.route('/registration')))
        }, _hoisted_10)
      ])
    ])
  ]))
}